import React from 'react';

import useCurrentWpPlatform from '../../hooks/useCurrentWpPlatform';

import OnboardingSnackbar from './snackbars/OnboardingSnackbar';

export default function SamplePlatformOnboardingManager(): JsxNode {
  const { data } = useCurrentWpPlatform();
  const platform = data?.Platform;
  if (!platform) {
    return null;
  }
  const { activeWaypointTier } = platform;
  if (activeWaypointTier !== 'SAMPLE') {
    return null;
  }

  return <OnboardingSnackbar />;
}
